import angular from 'angular';

import SpinnerController from './spinnerController';
import SpinnerDirective from './spinnerDirective';
import SpinnerService from './spinnerService';


export default angular.module('app.common.spinner', [])
    .controller('SpinnerController', SpinnerController)
    .service('raSpinnerService', SpinnerService)
    .directive('raSpinner', SpinnerDirective)
    .run(($templateCache) => {
        $templateCache.put('app/common/spinner/template/defaultSpinnerTemplate.html', require('./template/defaultSpinnerTemplate.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/spinner/template/indeterminateSpinner.html', require('./template/indeterminateSpinner.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/spinner/template/indeterminateSpinnerSmall.html', require('./template/indeterminateSpinnerSmall.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/spinner/template/indeterminateSpinnerSmallBlue.html', require('./template/indeterminateSpinnerSmallBlue.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/spinner/template/indeterminateSpinnerSmallGreen.html', require('./template/indeterminateSpinnerSmallGreen.html')); // eslint-disable-line global-require
        $templateCache.put('app/common/spinner/template/indeterminateSpinnerSmallRed.html', require('./template/indeterminateSpinnerSmallRed.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/common/spinner/index.js